import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, fromEvent, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GlobalKeyboardService implements OnDestroy {

  private _shortcutMap = new Map<string, string>();
  private _sub: Subscription | null = null;
  private _plateSearchSuppressed = false;

  /** Emite el primer carácter tecleado cuando no hay foco en un input */
  readonly plateSearch$ = new Subject<string>();

  /** Apertura programática de la ficha global de conductor con un término
   *  (código, placa, nombre o id) — misma ficha que la búsqueda por placa. */
  readonly openDriverFicha$ = new Subject<string>();

  openDriverFicha(term: string): void {
    this.openDriverFicha$.next(term);
  }

  constructor(private router: Router) {
    this._sub = fromEvent<KeyboardEvent>(document, 'keydown').subscribe(e => this._handle(e));
  }

  registerShortcuts(map: Map<string, string>): void {
    this._shortcutMap = map;
  }

  /** Suprime la búsqueda por placa mientras un componente maneja su propio teclado */
  suppressPlateSearch(value: boolean): void {
    this._plateSearchSuppressed = value;
  }

  private _handle(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    const inInput = ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)
      || target.isContentEditable;

    // ── Alt+Key → navegación ─────────────────────────────────────────
    if (event.altKey && !event.ctrlKey && !event.shiftKey && !event.metaKey) {
      const link = this._shortcutMap.get(event.key.toLowerCase());
      if (link) {
        event.preventDefault();
        this.router.navigate([link]);
      }
      return;
    }

    // ── Carácter alfanumérico fuera de inputs → búsqueda por placa ──
    if (!this._plateSearchSuppressed && !inInput && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
      if (/^[a-z0-9]$/i.test(event.key)) {
        event.preventDefault();
        this.plateSearch$.next(event.key.toUpperCase());
      }
    }
  }

  ngOnDestroy(): void {
    this._sub?.unsubscribe();
  }
}
